<ion-content>
  <div
    (click)="click($event, item)"
    *ngFor="let item of items"
    class="menu-item"
    [routerLink]="item.action ? null : item.path"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: item.matchExactPath }"
  >
    {{ 'NavbarItemEnum.' + item.key | transloco }}
    <app-badge *ngIf="item.notif" [count]="item.notif.count"></app-badge>
  </div>
</ion-content>
